import { Outlet } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { MobileNav } from "@/components/layout/MobileNav";
import { EnquiryDialog } from "@/components/EnquiryDialog";
import { MessageSquareText } from "lucide-react";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pb-20 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileNav />
      <div className="fixed bottom-20 right-4 z-40 lg:bottom-6">
        <EnquiryDialog trigger={
          <button data-testid="sticky-enquiry-btn" className="gold-btn rounded-full shadow-2xl px-5 py-3 font-semibold flex items-center gap-2">
            <MessageSquareText size={18} /> <span className="hidden sm:inline">Enquire</span>
          </button>} />
      </div>
    </div>
  );
}
